 $('.image_sliders').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button type="button" class="slick-prevs"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <path d="M15.5074 18.6668L17.1641 17.0218L14.1424 14.0002L17.1641 10.9902L15.5074 9.3335L10.8407 14.0002L15.5074 18.6668Z" fill="white" stroke="white" stroke-width="0.4"/> </svg></button>',
    nextArrow:'<button type="button" class="slick-nexts"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <path d="M15.5074 18.6668L17.1641 17.0218L14.1424 14.0002L17.1641 10.9902L15.5074 9.3335L10.8407 14.0002L15.5074 18.6668Z" fill="white" stroke="white" stroke-width="0.4"/> </svg></button>',
    dots: true,
  });
$('.Reviews_sliders').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false, adaptiveHeight: true,
    prevArrow:'<button type="button" class="slick-prevs"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <path d="M15.5074 18.6668L17.1641 17.0218L14.1424 14.0002L17.1641 10.9902L15.5074 9.3335L10.8407 14.0002L15.5074 18.6668Z" fill="white" stroke="white" stroke-width="0.4"/> </svg></button>',
    nextArrow:'<button type="button" class="slick-nexts"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <path d="M15.5074 18.6668L17.1641 17.0218L14.1424 14.0002L17.1641 10.9902L15.5074 9.3335L10.8407 14.0002L15.5074 18.6668Z" fill="white" stroke="white" stroke-width="0.4"/> </svg></button>',
    responsive: [
      {
        breakpoint: 768, // applies to screen widths <= 767px
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
   $('.milestones-gridssss').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    prevArrow:'<button type="button" class="slick-prevs"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <path d="M15.5074 18.6668L17.1641 17.0218L14.1424 14.0002L17.1641 10.9902L15.5074 9.3335L10.8407 14.0002L15.5074 18.6668Z" fill="white" stroke="white" stroke-width="0.4"/> </svg></button>',
    nextArrow:'<button type="button" class="slick-nexts"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"> <path d="M15.5074 18.6668L17.1641 17.0218L14.1424 14.0002L17.1641 10.9902L15.5074 9.3335L10.8407 14.0002L15.5074 18.6668Z" fill="white" stroke="white" stroke-width="0.4"/> </svg></button>',
    dots: false,
     responsive: [
      {
        breakpoint: 768, // applies to screen widths <= 767px
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
          centermode:true,
        },
      },
    ],
  });


 $('.Buttons_container button').click(function() {
  if ($(this).hasClass('slick-prevs')) {
    $('.milestones-grid button.slick-prevs.slick-arrow').click();
  } else {
    $('.milestones-grid button.slick-nexts.slick-arrow').click();
  }
});

$('.diesel-colors .diesel-color-circle').click(function (params) {
    $(this).addClass('active').siblings().removeClass('active')
    $('.diesel-feature-image img').attr('src',$(this).attr('data-src'))
})
$(document).ready(function() {

   var stringarry = window.location.href.split('&filter.p.tag=').slice(1);
   stringarry.forEach(t => {
      console.log(t,'t',stringarry)
      $(`.Tags_container button[data-add="${t}"]`).addClass('active')
    });
})

$(document).on("click",".Tags_container button",function() {
  console.log('click')
   var text = $(this).text().toLowerCase()
   $(`.facets__disclosure-vertical:has([filter_name="Tags"]) li input[value="${text}"]`).click()
    setTimeout(function() {
    var stringarry = window.location.href.split('&filter.p.tag=').slice(1);
    stringarry.forEach(t => {
    
      $(`.Tags_container button[data-add="${t}"]`).addClass('active')
    });
    }, 2000);
})